import CONTRATISTAS from '@/graphql/querys/administracion/catalogos/contratistas/contratistas.gql';
import AGREGAR_LICITACION_PARTICIPANTE from '@/graphql/mutations/administracion/licitaciones/participantes/agregarLicitacionParticipante.gql';
import LICITACION_PARTICIPANTES from '@/graphql/querys/administracion/licitaciones/participantes/licitacionParticipantes.gql';
import REMOVER_LICITACION_PARTICIPANTE from '@/graphql/mutations/administracion/licitaciones/participantes/removerLicitacionParticipante.gql';

export default {
  apollo: {
    contratistas: {
      query: CONTRATISTAS,
    },
  },
  methods: {
    async mixAgregarLicitacionParticipante() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo.mutate({
        mutation: AGREGAR_LICITACION_PARTICIPANTE,
        variables: {
          idLicitacion: this.idLicitacion,
          idContratista: this.licitacionParticipante.idContratista,
        },
        update: (store, { data: { agregarLicitacionParticipante } }) => {
          const data = store.readQuery({
            query: LICITACION_PARTICIPANTES,
            variables: {
              idLicitacion: this.idLicitacion,
            },
          });
          data.licitacionParticipantes.push(agregarLicitacionParticipante);
          store.writeQuery({ query: LICITACION_PARTICIPANTES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixEliminarLicitacionParticipante() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_LICITACION_PARTICIPANTE,
        variables: {
          id: this.participanteEliminar.id,
        },
        update: (store) => {
          const data = store.readQuery({
            query: LICITACION_PARTICIPANTES,
            variables: {
              idLicitacion: this.participanteEliminar.idLicitacion,
            },
          });
          const { licitacionParticipantes } = data;
          const index = licitacionParticipantes
            .findIndex((participante) => participante.id === this.participanteEliminar.id);
          if (index !== -1) {
            licitacionParticipantes.splice(index, 1);
          }
          store.writeQuery({ query: LICITACION_PARTICIPANTES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
